$(document).on("click", ".language-link", (event) => {
  const language = $(event.target).data("language");
  const expiration_date = new Date();
  let cookie_string = "";
  expiration_date.setFullYear(expiration_date.getFullYear() + 30);
  cookie_string = `selected_language=${language}; path=/; expires=${expiration_date.toUTCString()}`;
  document.cookie = cookie_string;
});
